<div class="container-fluid p-4 h-100 overflow-auto">
    <!-- Top Section -->
    <div class="card border-0 shadow-sm mb-4">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 class="mb-0 text-secondary">{{ title }}</h4>
                </div>
                <div class="d-flex align-items-end mt-3 mt-md-0">
                    <dx-date-range-box
                        [multiView]="false"
                        [showClearButton]="true"
                        [(value)]="dateRangeFilterValue"
                        (onValueChanged)="onDateRangeChanged($event)"
                        stylingMode="filled"
                    >
                    </dx-date-range-box>
                    <dx-button stylingMode="text" class="ms-3" icon="export" (onClick)="onExport()"></dx-button>
                </div>
            </div>

            <!-- Breakdown Charts -->
            <div class="card border-0">
                <div class="card-body text-center">
                    <div class="row row-cols-1 row-cols-md-3 g-4 justify-content-center">
                        @for (chartType of chartTypes; track chartType) {
                            <div class="col">
                                <h5 class="text-muted mb-3">{{ chartType | capitalCase }}</h5>
                                <div class="position-relative d-inline-block w-100">
                                    <app-doughnut-chart
                                        [from]="fromDate"
                                        [to]="toDate"
                                        [centerText]="chartType | capitalCase"
                                        [responsive]="false"
                                        [loadData]="loadScoreData(chartType)"
                                        [palette]="palette"
                                    ></app-doughnut-chart>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Trending Section -->
    <div class="card border-0 shadow-sm">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 class="mb-0 text-secondary">{{ trendingTitle }}</h4>
                </div>
                <div class="d-flex align-items-end mt-3 mt-md-0">
                    <dx-select-box
                        [items]="trendingFilterOptions"
                        [(value)]="trendingFilterValue"
                        valueExpr="value"
                        displayExpr="text"
                        stylingMode="filled"
                    >
                    </dx-select-box>
                </div>
            </div>

            <div class="mb-5">
                <app-trending
                    [aggregateType]="trendingFilterValue"
                    [loadData]="loadTrendingData"
                ></app-trending>
            </div>
        </div>
    </div>
</div>
